import "./App.css";
import { ConfigProvider, App, theme } from "antd";
import Homepage from "./pages/homepage";
import { GlobalStateProvider } from "./utils/globalState";

const GOLD = "#d4af37";
const GOLD_LINE = "rgba(232, 195, 122, 0.22)";

function MyApp() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: GOLD,
          colorInfo: GOLD,
          colorLink: "#e8c37a",
          colorBgBase: "#0b0b0e",
          colorTextBase: "#eee9de",
          colorBorder: GOLD_LINE,
          colorBorderSecondary: "rgba(232, 195, 122, 0.12)",
          colorBgContainer: "rgba(5, 5, 7, 0.45)",
          colorBgElevated: "#111115",
          cellPaddingBlock: 4,
          borderRadius: 7,
          fontFamily:
            '"Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
        },
        components: {
          Layout: {
            bodyBg: "transparent",
            headerBg: "transparent",
            siderBg: "transparent",
          },
          Menu: {
            darkItemBg: "transparent",
            darkSubMenuItemBg: "transparent",
            darkItemColor: "#b8b4aa",
            darkItemHoverColor: "#f8e8b8",
            darkItemHoverBg: "rgba(232, 195, 122, 0.055)",
            darkItemSelectedBg: "rgba(212, 175, 55, 0.16)",
            darkItemSelectedColor: "#f8e8b8",
            itemHeight: 44,
            itemBorderRadius: 9,
          },
          Select: {
            selectorBg: "#09090c",
            optionSelectedBg: "rgba(212, 175, 55, 0.16)",
            optionActiveBg: "rgba(232, 195, 122, 0.08)",
            colorBgElevated: "#111115",
          },
          Input: {
            colorBgContainer: "#09090c",
            activeBorderColor: "rgba(232, 195, 122, 0.62)",
            hoverBorderColor: "rgba(232, 195, 122, 0.45)",
            activeShadow: "0 0 0 3px rgba(212, 175, 55, 0.07)",
          },
          Checkbox: {
            colorBgContainer: "#09090c",
          },
          Table: {
            colorBgContainer: "transparent",
            headerBg: "rgba(212, 175, 55, 0.09)",
            headerColor: "#b6aa90",
            headerSplitColor: "transparent",
            borderColor: "rgba(232, 195, 122, 0.14)",
            rowHoverBg: "rgba(212, 175, 55, 0.04)",
          },
          Modal: {
            contentBg: "#111115",
            headerBg: "transparent",
          },
          Alert: {
            colorWarningBg: "rgba(212, 175, 55, 0.08)",
            colorWarningBorder: "rgba(232, 195, 122, 0.26)",
          },
          Message: {
            contentBg: "rgba(17, 17, 21, 0.98)",
          },
          Button: {
            defaultBg: "rgba(212, 175, 55, 0.08)",
            defaultBorderColor: "rgba(232, 195, 122, 0.32)",
            defaultColor: "#e7d9b8",
            primaryShadow: "none",
          },
        },
      }}
    >
      <GlobalStateProvider>
        <App>
          <Homepage />
        </App>
      </GlobalStateProvider>
    </ConfigProvider>
  );
}

export default MyApp;
